/**
 * Vue Router Configuration
 *
 * Определяет маршруты приложения и навигацию между страницами.
 */

import { createRouter, createWebHistory } from 'vue-router';

import { useAuthStore } from '@/stores/auth';
import { useUserStore } from '@/stores/user';

const router = createRouter({
	history: createWebHistory(import.meta.env.BASE_URL),
	routes: [
		{
			path: '/',
			name: 'home',
			component: () => import('@/views/HomeView.vue')
		},
		{
			path: '/tournament/create',
			name: 'create-tournament',
			component: () => import('@/views/CreateTournamentView.vue')
		},
		{
			path: '/tournament/:id',
			name: 'tournament',
			component: () => import('@/views/TournamentView.vue')
		},
		{
			path: '/auth/callback',
			name: 'auth-callback',
			component: () => import('@/views/AuthCallbackView.vue'),
			meta: { isAuthCallback: true }
		},
		{
			path: '/club/join/:code',
			name: 'club-join',
			component: () => import('@/views/ClubJoinView.vue')
		},
		{
			path: '/club/:id',
			name: 'club',
			component: () => import('@/views/ClubView.vue'),
			beforeEnter: to => {
				if (!Number.isFinite(Number(to.params.id))) return '/';
			}
		},
		{
			path: '/season/:id',
			name: 'season',
			component: () => import('@/views/SeasonView.vue'),
			beforeEnter: to => {
				if (!Number.isFinite(Number(to.params.id))) return '/';
			}
		},
		{
			path: '/privacy',
			name: 'privacy',
			component: () => import('@/views/PrivacyView.vue')
		},
		{
			path: '/terms',
			name: 'terms',
			component: () => import('@/views/TermsView.vue')
		},
		{
			path: '/account',
			name: 'account',
			component: () => import('@/views/AccountView.vue'),
			beforeEnter: () => {
				const userStore = useUserStore();
				if (!userStore.isAuthenticated) return '/';
			}
		}
	]
});

// Navigation guard для установки текущего турнира
router.beforeEach((to, _from, next) => {
	if (to.name === 'tournament') {
		const authStore = useAuthStore();
		const tournamentId = Number(to.params.id);

		if (Number.isFinite(tournamentId)) {
			authStore.setCurrentTournament(tournamentId);
		}
	}

	next();
});

export default router;
